import script from "./ChangePlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePlan.vue?vue&type=script&setup=true&lang=ts"

import "./ChangePlan.vue?vue&type=style&index=0&id=956155e8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-956155e8"]])

export default __exports__